import { NextPage } from 'next';
import ProjectLayout from '@layouts/project-layout/project-layout';
import Level01Component from '@components/projects/level01/level01';
import { ProjectProps } from '@models/project.interface';

const Level01: NextPage<ProjectProps> = (project) => {
  return (
    <ProjectLayout project={project}>
      <Level01Component breadcrumbsText={project.project.breadcrumbsText} />
    </ProjectLayout>
  );
};

export default Level01;
export { getServerSideProps } from '@layouts/project-layout/project-layout';
